import { ExternalLink } from '../../elements/atoms/externalLink/ExternalLink';
import { HeroText } from '../../elements/atoms/heroText/HeroText';
import { PageTitle } from '../../elements/atoms/pageTitle/PageTitle';
import { FaqItem } from '../../elements/molecules/faqItem/FaqItem';
import { PageWrapperWithHeader } from '../../elements/organisms/pageWrapper/PageWrapperWithHeader';
import { FAQ_POSTS } from './faqData';

export function OsasFaq() {
    const contactEmail = <ExternalLink href="mailto:polikliniek@ksyos.nl">polikliniek@ksyos.nl</ExternalLink>;

    return (
        <PageWrapperWithHeader>
            <PageTitle>Veelgestelde vragen</PageTitle>
            <HeroText>
                Hier vind je de meest voorkomende vragen. Staat jouw vraag er niet tussen? Neem dan contact met ons op
                via {contactEmail} of <ExternalLink href="tel:020-2366533">020 600 00 60</ExternalLink>.
            </HeroText>
            {FAQ_POSTS.map((faqPost) => (
                <FaqItem
                    answer={faqPost.answer}
                    key={faqPost.id}
                    question={faqPost.question}
                />
            ))}
        </PageWrapperWithHeader>
    );
}
